module.exports = "img/prac-info-slide-7.761453.jpeg";